import { fetchJson, post } from "./Fetching";

const findSamples = (company_id, sample_ids, params = {}) => {
  return fetchJson("/lims_sample_reporting/samples.json", {
    company_id,
    form: {
      company_id,
      sample_ids,
      ...params,
    },
  })
    .then((json) => {
      return json.sample_list;
    })
    .catch((e) => {
      alert("Problem loading samples.");
    });
};

const findSamplesPost = (company_id, sample_ids, params = {}) => {
  return post("/lims_sample_reporting/samples.json", {
    company_id,
    form: {
      company_id,
      sample_ids,
      ...params,
    },
  })
    .then((json) => {
      return json.sample_list;
    })
    .catch((e) => {
      alert("Problem loading samples.");
    });
};

const fetchSampleQuotables = (sampleId) => {
  return fetchJson("/quoting/quotables/sample_quotables", {
    id: sampleId,
  });
};

export { findSamples, fetchSampleQuotables, findSamplesPost };
